import React from "react";
import "./Button.scss";
import UtilServices from "@services/UtilServices";

export default function Button({
  nome = "",
  icon = "",
  className = "",
  onClick = () => null,
  theme = "1",
  disabled = false,
  title = "",
  type = "submit",
}) {
  return (
    <div className={`Button`}>
      <button
        className={`${className} theme${theme} ${disabled ? "disabled" : ""} ${
          icon ? "icon" : ""
        }`}
        onClick={onClick}
        disabled={disabled}
        type={type}
        data-tooltip-id="tooltip-001"
        data-tooltip-html={title}
      >
        {UtilServices.stringToJsx(icon)}
        <p>{nome}</p>
      </button>
    </div>
  );
}
